import { defineStore } from 'pinia'
import { ref } from 'vue'

/** 生成一个随机字符串（字母数字混合） */
function generateRandomString(length = 8): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

export const useRandomArrayStore = defineStore('randomArray', () => {
  // 初始化时直接生成 6 个随机字符串的数组
  const randomArray = ref<string[]>(Array.from({ length: 7 }, () => generateRandomString()))

  return { randomArray }
})